const FinancialIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={32}
    height={32}
    viewBox='0 0 32 32'
    fill='none'
    {...props}>
    <path
      stroke='currentColor'
      strokeMiterlimit={10}
      strokeWidth={1.01}
      d='M13.39 19.243c0 1.162 1.155 2.103 2.58 2.103 1.423 0 2.578-.941 2.578-2.103 0-2.581-5.157-2.926-5.157-5.558 0-1.162 1.154-2.103 2.578-2.103s2.579.941 2.579 2.103M15.973 21.346v2.49M15.973 9.092v2.49'
    />
    <path
      stroke='currentColor'
      strokeMiterlimit={10}
      strokeWidth={1.01}
      d='M31.181 6H.75v20.93h30.431z'
    />
    <path
      stroke='currentColor'
      strokeMiterlimit={10}
      strokeWidth={1.01}
      d='M6.833 6v1.9c0 2.24-1.855 4.056-4.143 4.056H.75M25.106 6v1.9c0 2.24 1.854 4.056 4.142 4.056h1.94M6.833 26.927v-1.9c0-2.24-1.855-4.056-4.143-4.056H.75M25.106 26.927v-1.9c0-2.24 1.854-4.056 4.142-4.056h1.94'
    />
  </svg>
)

export default FinancialIcon
